import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../../ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

export const LandingNavbar = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMobileMenuOpen(false);

  const navBgClass = (isScrolled || !isHomePage)
    ? 'bg-white/95 backdrop-blur-md shadow-sm border-b border-meetoi-aqua/30'
    : 'bg-transparent';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBgClass}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" onClick={closeMenu} className="flex items-center space-x-2.5 z-50">
            <div className="w-9 h-9 bg-meetoi-navy rounded-xl flex items-center justify-center shadow-sm">
              <SafeIcon icon={FiIcons.FiLayers} className="text-white text-xl" />
            </div>
            <span className="font-sora text-2xl font-bold text-meetoi-navy tracking-tight">Meetoi</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/#how-it-works" className="text-sm font-semibold font-manrope text-meetoi-text hover:text-meetoi-blue transition-colors">How it works</Link>
            <Link to="/#features" className="text-sm font-semibold font-manrope text-meetoi-text hover:text-meetoi-blue transition-colors">Features</Link>
            <Link to="/#intelligence" className="text-sm font-semibold font-manrope text-meetoi-text hover:text-meetoi-blue transition-colors">Intelligence</Link>
          </nav>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/login" className="text-sm font-semibold font-manrope text-meetoi-text hover:text-meetoi-blue transition-colors">Log in</Link>
            <Link to="/register">
              <Button size="md" className="bg-meetoi-navy hover:bg-meetoi-navy/90 text-white rounded-xl px-5 font-manrope font-semibold border-0">
                Get started
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="md:hidden flex items-center z-50">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 -mr-2 text-meetoi-text hover:text-meetoi-blue focus:outline-none"
            >
              <SafeIcon icon={mobileMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <div
        className={`md:hidden absolute top-20 left-0 w-full bg-white border-b border-meetoi-aqua/30 shadow-xl transition-all duration-300 ease-in-out ${
          mobileMenuOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-4'
        }`}
      >
        <div className="px-4 pt-4 pb-8 space-y-4 flex flex-col font-manrope">
          <Link to="/#how-it-works" onClick={closeMenu} className="block px-4 py-3 text-base font-semibold text-meetoi-navy bg-meetoi-offwhite rounded-xl">How it works</Link>
          <Link to="/#features" onClick={closeMenu} className="block px-4 py-3 text-base font-semibold text-meetoi-navy bg-meetoi-offwhite rounded-xl">Features</Link>
          <Link to="/#intelligence" onClick={closeMenu} className="block px-4 py-3 text-base font-semibold text-meetoi-navy bg-meetoi-offwhite rounded-xl">Intelligence</Link>
          
          <div className="h-px bg-meetoi-aqua/30 my-2"></div>
          
          <Link to="/login" onClick={closeMenu} className="block px-4 py-3 text-base font-semibold text-meetoi-text text-center">Log in</Link>
          <Link to="/register" onClick={closeMenu} className="block">
            <Button className="w-full bg-meetoi-navy hover:bg-meetoi-navy/90 text-white rounded-xl py-4 text-base font-semibold border-0">
              Get started
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
};